/**
 * 文件类型图标映射
 *
 * 将文件类型映射到本地图标路径
 * 这些图标原本来自GitHub，现在存储在本地以避免CORS问题
 */

// 基本路径
const BASE_PATH = '/icons/file-types';

// 文件类型到图标的映射
export const fileTypeIcons: Record<string, string> = {
  // 压缩文件
  '7z': `${BASE_PATH}/sevenzip.png`,
  'zip': `${BASE_PATH}/zip.png`,
  'rar': `${BASE_PATH}/rar.png`,
  'tar': `${BASE_PATH}/tar.png`,
  'gz': `${BASE_PATH}/gzip.png`,
  'gzip': `${BASE_PATH}/gzip.png`,
  'bz': `${BASE_PATH}/bz.png`,
  'bz2': `${BASE_PATH}/bz2.png`,
  'freearc': `${BASE_PATH}/freearc.png`,

  // 音频文件
  'aac': `${BASE_PATH}/aac.png`,
  'midi': `${BASE_PATH}/midi.png`,
  'mp3': `${BASE_PATH}/mp3.png`,
  'oga': `${BASE_PATH}/oga.png`,
  'opus': `${BASE_PATH}/opus.png`,
  'wav': `${BASE_PATH}/wav.png`,
  'weba': `${BASE_PATH}/weba.png`,
  'wma': `${BASE_PATH}/wma.png`,
  'cda': `${BASE_PATH}/cda.png`,

  // 视频文件
  'avi': `${BASE_PATH}/avi.png`,
  'mov': `${BASE_PATH}/mov.png`,
  'mp4': `${BASE_PATH}/mp4.png`,
  'mpeg': `${BASE_PATH}/mpeg.png`,
  'ogv': `${BASE_PATH}/ogv.png`,
  'webm': `${BASE_PATH}/webm.png`,
  'wmv': `${BASE_PATH}/wmv.png`,

  // 图像文件
  'bmp': `${BASE_PATH}/bmp.png`,
  'gif': `${BASE_PATH}/gif.png`,
  'jpeg': `${BASE_PATH}/jpeg.png`,
  'jpg': `${BASE_PATH}/jpeg.png`,
  'png': `${BASE_PATH}/png.png`,
  'svg': `${BASE_PATH}/svg.png`,
  'tiff': `${BASE_PATH}/tiff.png`,
  'tif': `${BASE_PATH}/tiff.png`,
  'webp': `${BASE_PATH}/webp.png`,
  'psd': `${BASE_PATH}/psd.png`,
  'eps': `${BASE_PATH}/eps.png`,

  // 文档文件
  'abw': `${BASE_PATH}/abw.png`,
  'doc': `${BASE_PATH}/docx.png`,
  'docx': `${BASE_PATH}/docx.png`,
  'odt': `${BASE_PATH}/odt.png`,
  'pdf': `${BASE_PATH}/pdf.png`,
  'rtf': `${BASE_PATH}/rtf.png`,
  'txt': `${BASE_PATH}/text.png`,
  'text': `${BASE_PATH}/text.png`,
  'epub': `${BASE_PATH}/epub.png`,
  'azw': `${BASE_PATH}/azw.png`,

  // 表格文件
  'csv': `${BASE_PATH}/csv.png`,
  'xls': `${BASE_PATH}/xlsx.png`,
  'xlsx': `${BASE_PATH}/xlsx.png`,
  'ods': `${BASE_PATH}/ods.png`,

  // 演示文件
  'ppt': `${BASE_PATH}/pptx.png`,
  'pptx': `${BASE_PATH}/pptx.png`,
  'odp': `${BASE_PATH}/odp.png`,

  // 编程和标记语言
  'c': `${BASE_PATH}/c.png`,
  'cpp': `${BASE_PATH}/c.png`,
  'css': `${BASE_PATH}/css.png`,
  'html': `${BASE_PATH}/html.png`,
  'java': `${BASE_PATH}/java.png`,
  'jar': `${BASE_PATH}/jar.png`,
  'js': `${BASE_PATH}/javascript.png`,
  'javascript': `${BASE_PATH}/javascript.png`,
  'json': `${BASE_PATH}/json.png`,
  'jsonld': `${BASE_PATH}/jsonld.png`,
  'php': `${BASE_PATH}/php.png`,
  'py': `${BASE_PATH}/python.png`,
  'python': `${BASE_PATH}/python.png`,
  'sass': `${BASE_PATH}/sass.png`,
  'scss': `${BASE_PATH}/sass.png`,
  'sh': `${BASE_PATH}/sh.png`,
  'bash': `${BASE_PATH}/sh.png`,
  'ts': `${BASE_PATH}/typescript.png`,
  'typescript': `${BASE_PATH}/typescript.png`,
  'xml': `${BASE_PATH}/xml.png`,
  'jsx': `${BASE_PATH}/react.png`,
  'tsx': `${BASE_PATH}/react.png`,
  'vue': `${BASE_PATH}/vue.png`,

  // 字体文件
  'eot': `${BASE_PATH}/eot.png`,
  'otf': `${BASE_PATH}/otf.png`,
  'ttf': `${BASE_PATH}/ttf.png`,
  'woff': `${BASE_PATH}/woff.png`,
  'woff2': `${BASE_PATH}/woff.png`,

  // 其他文件类型
  'accdb': `${BASE_PATH}/accdb.png`,
  'csh': `${BASE_PATH}/csh.png`,
  'drawio': `${BASE_PATH}/drawio.png`,
  'dw': `${BASE_PATH}/dw.png`,
  'eml': `${BASE_PATH}/eml.png`,
  'icalendar': `${BASE_PATH}/icalendar.png`,
  'ind': `${BASE_PATH}/ind.png`,
  'ini': `${BASE_PATH}/ini.png`,
  'jsf': `${BASE_PATH}/jsf.png`,
  'mpkg': `${BASE_PATH}/mpkg.png`,
  'octet': `${BASE_PATH}/octet.png`,
  'ogx': `${BASE_PATH}/ogx.png`,
  'proj': `${BASE_PATH}/proj.png`,
  'pst': `${BASE_PATH}/pst.png`,
  'publisher': `${BASE_PATH}/publisher.png`,
  'richtextformat': `${BASE_PATH}/richtextformat.png`,
  'settings': `${BASE_PATH}/settings.png`,
  'swf': `${BASE_PATH}/swf.png`,
  'url': `${BASE_PATH}/url.png`,
  'vsd': `${BASE_PATH}/vsd.png`,
  'xul': `${BASE_PATH}/xul.png`,
};

/**
 * 根据文件类型或MIME类型获取图标路径
 * @param fileType 文件类型或MIME类型
 * @returns 图标路径
 */
export function getFileIconByType(fileType: string): string {
  // 处理MIME类型 (例如 "image/png" -> "png")
  const extension = fileType.includes('/')
    ? fileType.split('/')[1]
    : fileType;

  // 移除可能的点前缀 (例如 ".pdf" -> "pdf")
  const cleanExtension = extension.startsWith('.')
    ? extension.substring(1)
    : extension;

  // 查找图标，如果没有找到则返回通用图标
  return fileTypeIcons[cleanExtension.toLowerCase()] || `${BASE_PATH}/octet.png`;
}

/**
 * 根据文件名获取图标路径
 * @param fileName 文件名
 * @returns 图标路径
 */
export function getFileIconByName(fileName: string): string {
  const extension = fileName.split('.').pop() || '';
  return getFileIconByType(extension);
}

/**
 * 根据文件扩展名生成一个稳定的颜色
 * @param extension 文件扩展名
 * @returns 颜色的HEX值
 */
export function getColorForExtension(extension: string): string {
  // 确保扩展名是小写的
  const ext = extension.toLowerCase();

  // 为常见文件类型指定固定颜色
  const typeColors: Record<string, string> = {
    // 文档
    'pdf': '#FF5A5F',  // 红色
    'doc': '#2B579A',  // Word蓝色
    'docx': '#2B579A', // Word蓝色
    'txt': '#4F4F4F',  // 灰色

    // 表格
    'xls': '#217346',  // Excel绿色
    'xlsx': '#217346', // Excel绿色
    'csv': '#217346',  // Excel绿色

    // 演示文稿
    'ppt': '#D24726',  // PowerPoint橙色
    'pptx': '#D24726', // PowerPoint橙色

    // 图像
    'jpg': '#00A699',  // 青色
    'jpeg': '#00A699', // 青色
    'png': '#7B0051',  // 紫色
    'gif': '#FF8C38',  // 橙色
    'svg': '#FF8C38',  // 橙色

    // 音频
    'mp3': '#007AFF',  // iOS蓝色
    'wav': '#007AFF',  // iOS蓝色

    // 视频
    'mp4': '#FF3B30',  // iOS红色
    'mov': '#FF3B30',  // iOS红色

    // 压缩文件
    'zip': '#8E8E93',  // iOS灰色
    'rar': '#8E8E93',  // iOS灰色

    // 代码
    'html': '#E44D26', // HTML橙色
    'css': '#264DE4',  // CSS蓝色
    'js': '#F7DF1E',   // JavaScript黄色
    'ts': '#007ACC',   // TypeScript蓝色
    'py': '#3776AB',   // Python蓝色
    'java': '#007396', // Java蓝色
  };

  // 如果有预定义的颜色，使用它
  if (ext in typeColors) {
    return typeColors[ext];
  }

  // 否则，根据扩展名生成一个稳定的颜色
  let hash = 0;
  for (let i = 0; i < ext.length; i++) {
    hash = ext.charCodeAt(i) + ((hash << 5) - hash);
  }

  // 将哈希值转换为颜色
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    color += ('00' + value.toString(16)).substr(-2);
  }

  return color;
}

/**
 * 获取文件扩展名（不带点）
 * @param fileName 文件名
 * @returns 文件扩展名
 */
export function getFileExtension(fileName: string): string {
  return (fileName.split('.').pop() || '').toLowerCase();
}

export default fileTypeIcons;
